var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeSentiment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2304_2865)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0865 11.5615C16.3625 8.53953 15.2172 4.9697 12.3029 3.28714C10.1969 2.07126 7.69933 2.14813 5.729 3.27155L4.91044 1.83892C7.37335 0.434673 10.4953 0.338585 13.1278 1.85843C16.832 3.99704 18.2499 8.57475 16.5241 12.3916L17.6309 13.0306L14.1953 14.8569L14.0592 10.9684L15.0865 11.5615ZM2.92042 6.44238C1.64438 9.46437 2.78972 13.0342 5.704 14.7168C7.80995 15.9326 10.3075 15.8558 12.2777 14.7324L13.0963 16.1651C10.6335 17.5692 7.5116 17.6653 4.87914 16.1455C1.17498 14.0069 -0.242963 9.42914 1.48278 5.61236L0.375977 4.97335L3.81159 3.14702L3.94774 7.0355L2.92042 6.44238Z",
    fill: "#25262D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9174 6.25295L9.65622 4.33367C9.54134 4.15884 9.30649 4.11024 9.13166 4.22512L8.8151 4.43313C8.60033 5.47104 7.65376 6.59551 7.03414 7.24085L9.27529 10.6516C10.1135 10.3389 11.5213 9.91638 12.5592 10.1312L12.8758 9.92314C13.0506 9.80826 13.0992 9.57341 12.9843 9.39858L11.7232 7.4793C11.9501 7.22959 11.989 6.84911 11.7951 6.55411C11.6013 6.25911 11.2366 6.1438 10.9174 6.25295ZM5.21533 8.61146C4.86567 8.84122 4.76848 9.31093 4.99823 9.66059L6.24628 11.5599C6.47604 11.9096 6.94575 12.0068 7.29541 11.777L7.61196 11.569L8.96856 12.9438L9.60167 12.5278L6.48156 7.77943L5.21533 8.61146Z",
    fill: "#25262D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2304_2865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeSentiment);
export default __webpack_public_path__ + "static/media/change-sentiment.9b3b9d052f43b946ac0ac7e68bdcf0c2.svg";
export { ForwardRef as ReactComponent };